module.exports = __webpack_public_path__ + "static/media/mediaGridIconActive.c56a773e.svg";